<!--编辑资料-->
<template>
  <div class="edit-container" :style="'min-height:'+min_height+'px;'">
    <div class="edit-content">
      <div class="portrait">
        <el-avatar fit="cover" :src="userInfo.useravatar" :size="110"></el-avatar>
      </div>
      <div class="userName">
        <p class="SourceHanSansCN">{{ userInfo.userID }}</p>
      </div>
      <div class="tips">
        <p>每一个月只能修改一次，请勿输入特殊符号</p>
      </div>
      <div class="btn">
        <el-button type="danger" @click="dialogVisible=true">修改昵称</el-button>
      </div>
    </div>
    <el-dialog title="修改昵称" :visible.sync="dialogVisible" width="20%">
      <el-form :model="userForm" :rules="rules" ref="userForm">
        <el-form-item prop="userName">
          <el-input v-model="userForm.userName" placeholder="输入昵称"/>
        </el-form-item>
      </el-form>
      <span style="color: #999999;font-size: 12px;">每一个月只能修改一次，请勿输入特殊符号，最多10字</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {getCustomInfo, modifyUserNickname} from '@/api/systemSetting'
export default {
  name: "editInformation",
  data() {
    return {
      userInfo: {},
      min_height: document.documentElement.clientHeight - 346,
      dialogVisible: false,
      userForm:{
        userName:'',
      },
      rules: {
        userName: [
          {required: true, message: '请输昵称', trigger: 'blur'},
          {min: 1,max: 10, message: '请勿输入特殊符号，最多10字', trigger: 'blur'}
        ],
      }
    }
  },
  methods:{
    submitEdit(){
      let cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          modifyUserNickname({
            nickName: this.userForm.userName,
            uid: cid!=0 && cid!=undefined ? cid : 0
          }).then(res=>{
            if (res.code==200){
              this.$message.success(res.msg);
              this.dialogVisible=false;
              this.getUserInfo();
            }
          })
        } else {
          return false;
        }
      });
    },
    getUserInfo(){
      let cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      if (cid!=0 && cid!=undefined){
        getCustomInfo({cid:cid,uid:cid}).then(res => {
          this.userInfo = res.data;
        })
      }
    }
  },
  mounted() {
    this.getUserInfo();
  }
}
</script>
<style scoped>
.edit-container >>> .edit-content .btn .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  float: right;
  padding: 15px 60px;
  margin-top: 10px;
}

.edit-container >>> .edit-content .btn .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
.dialog-footer >>> .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
}
.dialog-footer >>> .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
</style>
<style scoped lang="scss">
.edit-container {
  background: #ffffff;

  .edit-content {
    padding: 30px;

    .portrait {
      display: flex;
      justify-content: center;
    }

    .userName {
      display: flex;
      justify-content: center;

      p {
        font-size: 18px;
        color: #333333;
        margin-block-end: 0px;
      }
    }

    .tips {
      display: flex;
      justify-content: center;
      font-size: 14px;
      color: #666666;
    }

    .btn {
      display: flex;
      justify-content: center;
    }
  }
}
</style>